import { render, staticRenderFns } from "./WPAccessPopup.vue?vue&type=template&id=5a7af8ec&scoped=true"
import script from "./WPAccessPopup.vue?vue&type=script&lang=js"
export * from "./WPAccessPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7af8ec",
  null
  
)

export default component.exports